import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { TodoListTrackerIcon } from 'BreetAssets';
import { capitalizeFirstLetters } from 'BreetHelpers';

import type { IDialogOnboardingTodoListItem } from './DialogOnboardingTodoList.helpers';

const DialogOnboardingTodoListItem = ({
	header,
	status,
	subHeader,
	onClick,
	isLast,
	btnTitle,
}: IDialogOnboardingTodoListItem) => (
	<div className='todo-list-item'>
		<div className='todo-list-left'>
			<div className='progress-tracker'>
				<TodoListTrackerIcon
					status={status}
					className={classNameMerger('svg-dark svg-dark-outline', status === 'pending' && 'svg-dark-outline')}
				/>

				{!isLast && <div className={classNameMerger('progress-tracker-tail bg-dark-navy', status)} />}
			</div>

			<div className='todo-list-item-txt'>
				<Typography
					as='h6'
					className={classNameMerger(status === 'pending' ? 'color-primary-100' : 'color-tertiary-400')}
				>
					{header}
				</Typography>
				<Typography className='color-primary-100'>{subHeader}</Typography>
			</div>
		</div>

		<Button
			className={classNameMerger('todo-list-item-status', 'theme-background-none', status)}
			onClick={status === 'get-started' ? onClick : undefined}
			variant='native'
		>
			{capitalizeFirstLetters(btnTitle ?? status)}
		</Button>
	</div>
);

export default DialogOnboardingTodoListItem;
